import { ZonedDate } from '@eika-infrastruktur/date';

import type { AccountNumber, Currency } from '../../../../generated-types';
import { CommonPaymentState } from '../../form/CommonPaymentState';

export type DownpaymentState = {
    note: string;
    currency?: Currency;
    firstBankingDateFromToday?: ZonedDate;
    showToAccounts: boolean;
    toAccount?: AccountNumber;
} & Omit<CommonPaymentState, 'toAccount' | 'kid'>;

export const downpaymentInitialState: DownpaymentState = {
    fromAccount: undefined,
    toAccount: undefined,
    amount: undefined,
    currency: 'NOK',
    note: '',
    showFromAccounts: false,
    showToAccounts: false,
    paymentDate: undefined,
};
